export const SET_MODAL_OPEN = 'SET_MODAL_OPEN';
export const SET_EDIT_EXPERIMENT_MODAL_OPEN = 'SET_EDIT_EXPERIMENT_MODAL_OPEN';
export const SET_MODAL_CLOSE = 'SET_MODAL_CLOSE';
export const SET_EXPERIMENT_INFO_LOADING = 'SET_EXPERIMENT_INFO_LOADING';
export const SET_EXPERIMENT_CREATION_LOADING = 'SET_EXPERIMENT_CREATION_LOADING';
export const SET_CALCULATION_LOADING = 'SET_CALCULATION_LOADING';
export const SET_PROCESS = 'SET_PROCESS';
